export const fisherItems = [
  {
    name: "Grade 0",
    description: "No SAH or IVH",
    value: "0",
    interpretation: ""
  },
  {
    name: "Grade 1",
    description: "Thin SAH (< 1mm), No IVH",
    value: "1",
    interpretation: ""
  },
  {
    name: "Grade 2",
    description: "Thin SAH (< 1mm), IVH present",
    value: "2",
    interpretation: ""
  },
  {
    name: "Grade 3",
    description: "Thick SAH (> 1mm), No IVH",
    value: "3",
    interpretation: ""
  },
  {
    name: "Grade 4",
    description: "Thick SAH (> 1mm), IVH present",
    value: "4",
    interpretation: ""
  }
]